export const USER_DEFAULT_FORMALISTE = 468;
